import style from '../../surveys.module.scss'
import { IQusteion } from 'src/utils/Interfaces/survey.interface'
import QuestionItem from '../QuestionItem'
import {
  useCreateQuestionMutation,
  useDeleteQuestionMutation,
  useGetQuestionsQuery,
  useUpdateQuestionMutation
} from 'src/redux/Api/surveysApi'

interface Props1 {
  surveyId: number
}

const QuestionBlock = ({ surveyId }: Props1) => {
  const { data: questions } = useGetQuestionsQuery(surveyId)
  const [createQuestion] = useCreateQuestionMutation()
  const [updateQuestion] = useUpdateQuestionMutation()
  const [deleteQuestion] = useDeleteQuestionMutation()
  const questionTemplate: IQusteion = {
    surveyId,
    questionText: 'New question',
    type: 'SINGLE',
    answers: []
  }

  const newQuestion = () => {
    createQuestion(questionTemplate)
  }

  const handleDeleteQuestion = (id: number) => {
    deleteQuestion(id)
  }

  const handleSaveQuestion = (question: IQusteion) => {
    updateQuestion(question)
  }

  return (
    <>
      <ul className={style.questions_list}>
        {questions?.map((question, index) => (
          <QuestionItem
            key={question.id}
            question={question}
            saveQuestion={handleSaveQuestion}
            deleteQuestion={() => handleDeleteQuestion(question.id as number)}
            index={index}
          />
        ))}
      </ul>
      <button className="btn" onClick={newQuestion}>
        Add question
      </button>
    </>
  )
}

export default QuestionBlock
